import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, vShow as _vShow, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9cb1cb40"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "h-100",
  style: {"overflow-x":"hidden"}
}
const _hoisted_2 = { class: "main-div" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-div" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "lbl-title" }, "Issue Sales Note"),
  /*#__PURE__*/_createElementVNode("span", { class: "lbl-remark" }, "Remarks : セールスノート未発行/回覧未完了のセールスについては、全数船積完了月の翌々月第四稼働日に削除される。")
], -1 /* HOISTED */))
const _hoisted_4 = { class: "dist-rdo-div" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Parent Distributor Code   ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Distributor Code ")
const _hoisted_7 = { class: "row-div" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "lbl-Search-Left" }, "Distributor Code :", -1 /* HOISTED */))
const _hoisted_9 = { class: "row-div" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "lbl-Search-Left" }, "Status :", -1 /* HOISTED */))
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "row-div" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "lbl-Search-Left" }, "Production Month :", -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "lblAscending" }, "Ascending", -1 /* HOISTED */))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "lblDescending" }, "Descending", -1 /* HOISTED */))
const _hoisted_19 = {
  id: "tbldiv",
  class: "tbl-div"
}
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"tblTitle-div\" style=\"width:calc(100% - 16px);\" data-v-9cb1cb40><table id=\"tblIssueSalesNote\" class=\"w-100\" data-v-9cb1cb40><tr data-v-9cb1cb40><th style=\"width:3%;\" data-v-9cb1cb40></th><th style=\"width:12%;\" data-v-9cb1cb40>Sales No.</th><th style=\"width:5%;\" data-v-9cb1cb40>NO.</th><th style=\"width:10%;\" data-v-9cb1cb40>Production Month</th><th style=\"width:10%;\" data-v-9cb1cb40>Factory</th><th style=\"width:20%;\" data-v-9cb1cb40>Status</th><th style=\"width:10%;\" data-v-9cb1cb40>Date of Issue</th><th style=\"width:10%;\" data-v-9cb1cb40>Date of Approval</th><th style=\"width:10%;\" data-v-9cb1cb40>Date of Agreement</th><th style=\"width:10%;\" data-v-9cb1cb40>CBU/KD</th></tr></table></div>", 1)
const _hoisted_21 = {
  id: "tblbodydiv",
  class: "tblbody-div"
}
const _hoisted_22 = {
  id: "tblIssueSalesNoteDetail",
  class: "w-100"
}
const _hoisted_23 = { id: "tbltbody" }
const _hoisted_24 = { style: {"width":"3%"} }
const _hoisted_25 = ["onUpdate:modelValue", "disabled", "onClick"]
const _hoisted_26 = { style: {"width":"12%","text-align":"left"} }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/PDFICON.png",
  alt: "image"
}, null, -1 /* HOISTED */))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { style: {"width":"5%"} }
const _hoisted_31 = { style: {"width":"10%"} }
const _hoisted_32 = { style: {"width":"10%"} }
const _hoisted_33 = { style: {"width":"20%"} }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { style: {"width":"10%"} }
const _hoisted_36 = { style: {"width":"10%"} }
const _hoisted_37 = { style: {"width":"10%"} }
const _hoisted_38 = { style: {"width":"10%"} }
const _hoisted_39 = { class: "btn-div" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { class: "valid-time-div" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "valid time am.8:00(JST) - pm7:00(JST)", -1 /* HOISTED */))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = {
  class: "modal fade",
  id: "showModal",
  tabindex: "-1",
  "aria-labelledby": "showModalLabel",
  "aria-hidden": "true"
}
const _hoisted_47 = { class: "modal-dialog modal-dialog-scrollable modal-lg" }
const _hoisted_48 = { class: "modal-content" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "showModalLabel"
  }, " Status Details "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    id: "modalCancel",
    class: "btn btn-primarydata close-btn",
    "data-bs-dismiss": "modal"
  }, " Close ")
], -1 /* HOISTED */))
const _hoisted_50 = {
  class: "modal-body",
  id: "modal-body",
  style: {"text-align":"left"}
}
const _hoisted_51 = { class: "tblbody-div-modal" }
const _hoisted_52 = { class: "row-div-name" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "lbl-Search-Left" }, "Distributor Name", -1 /* HOISTED */))
const _hoisted_54 = { class: "lbl-dada-display" }
const _hoisted_55 = { class: "row-div" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "lbl-Search-Left" }, "Sales No", -1 /* HOISTED */))
const _hoisted_57 = { class: "lbl-dada-display" }
const _hoisted_58 = { class: "row-div" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "lbl-Search-Left" }, "Status", -1 /* HOISTED */))
const _hoisted_60 = { class: "lbl-dada-display" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_63 = { class: "table-detail-modal" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "25%" }, "Issuer", -1 /* HOISTED */))
const _hoisted_65 = { width: "30%" }
const _hoisted_66 = { width: "35%" }
const _hoisted_67 = { width: "10%" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "25%" }, "SMC Confirmer", -1 /* HOISTED */))
const _hoisted_69 = { width: "30%" }
const _hoisted_70 = { width: "35%" }
const _hoisted_71 = { width: "10%" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "25%" }, "SMC Approver", -1 /* HOISTED */))
const _hoisted_73 = { width: "30%" }
const _hoisted_74 = { width: "35%" }
const _hoisted_75 = { width: "10%" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "25%" }, "Confirmer1", -1 /* HOISTED */))
const _hoisted_77 = { width: "30%" }
const _hoisted_78 = { width: "35%" }
const _hoisted_79 = { width: "10%" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "25%" }, "Confirmer2", -1 /* HOISTED */))
const _hoisted_81 = { width: "30%" }
const _hoisted_82 = { width: "35%" }
const _hoisted_83 = { width: "10%" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "25%" }, "Confirmer3", -1 /* HOISTED */))
const _hoisted_85 = { width: "30%" }
const _hoisted_86 = { width: "35%" }
const _hoisted_87 = { width: "10%" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "25%" }, "Confirmer4", -1 /* HOISTED */))
const _hoisted_89 = { width: "30%" }
const _hoisted_90 = { width: "35%" }
const _hoisted_91 = { width: "10%" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "25%" }, "Confirmer5", -1 /* HOISTED */))
const _hoisted_93 = { width: "30%" }
const _hoisted_94 = { width: "35%" }
const _hoisted_95 = { width: "10%" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "25%" }, "Approver", -1 /* HOISTED */))
const _hoisted_97 = { width: "30%" }
const _hoisted_98 = { width: "35%" }
const _hoisted_99 = { width: "10%" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Navigation"]),
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createVNode($setup["Alert"], {
      alertMessage: $setup.alertMessage,
      alertState: $setup.alertState
    }, null, 8 /* PROPS */, ["alertMessage", "alertState"]),
    _createVNode($setup["SalesNoteHeaderNavigation"]),
    _createVNode($setup["SalesNoteLinkNavigation"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          value: "0",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedDistMode) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelRadio, $setup.selectedDistMode]
        ]),
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          value: "1",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedDistMode) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelRadio, $setup.selectedDistMode]
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          maxlength: "6",
          class: "txtDistCD",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.txtDistCD) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, $setup.txtDistCD]
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary text-center btnSearch",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.goDetailSearch()))
        }, "Search")
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _withDirectives(_createElementVNode("select", {
          class: "selectStatus",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.selectedStatus) = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.statusInfoList, (statusInfo, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: statusInfo.status
            }, _toDisplayString(statusInfo.description), 9 /* TEXT, PROPS */, _hoisted_11))
          }), 128 /* KEYED_FRAGMENT */))
        ], 512 /* NEED_PATCH */), [
          [_vModelSelect, $setup.selectedStatus]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          value: "ASC",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.selectedProdMMMode) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelRadio, $setup.selectedProdMMMode]
        ]),
        _hoisted_14,
        _hoisted_15,
        _hoisted_16,
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          value: "DESC",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.selectedProdMMMode) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelRadio, $setup.selectedProdMMMode]
        ]),
        _hoisted_17,
        _hoisted_18
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("table", _hoisted_22, [
            _createElementVNode("tbody", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.issueSalesNoteList, (info, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_24, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": ($event: any) => ((info.isChecked) = $event),
                      disabled: info.isChkEnabled,
                      onClick: ($event: any) => ($setup.chkCheckEvent(info))
                    }, null, 8 /* PROPS */, _hoisted_25), [
                      [_vModelCheckbox, info.isChecked]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_26, [
                    _createTextVNode(_toDisplayString(info.salesNo) + " ", 1 /* TEXT */),
                    _withDirectives(_createElementVNode("a", {
                      class: "pdf_link",
                      onClick: ($event: any) => ($setup.showPDFFile(info))
                    }, _hoisted_29, 8 /* PROPS */, _hoisted_27), [
                      [_vShow, info.pdfIconShowFlg]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_30, _toDisplayString(info.seqNo), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_31, _toDisplayString(info.productionYM.slice(0, 4) + '/' + info.productionYM.slice(4, 6)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_32, _toDisplayString(info.factory_name), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_33, [
                    _createElementVNode("a", {
                      class: "status_link",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#showModal",
                      onClick: ($event: any) => ($setup.showModal(info))
                    }, _toDisplayString($setup.statusInfoList.find((i) => i.status === info.status)?.description), 9 /* TEXT, PROPS */, _hoisted_34)
                  ]),
                  _createElementVNode("td", _hoisted_35, _toDisplayString(info.issueDate), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_36, _toDisplayString(info.smcApproveDate), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_37, _toDisplayString(info.distributorApproveDate), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_38, _toDisplayString(info.prodTypeName), 1 /* TEXT */)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ])
      ], 512 /* NEED_PATCH */), [
        [_vShow, $setup.tblShowFlg]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_39, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn_cancel",
          disabled: $setup.btnCancelFlg,
          onClick: $setup.CancelSaleNote
        }, "Cancel Sales Note", 8 /* PROPS */, _hoisted_40),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn_circulation",
          disabled: $setup.btnCirculationFlg,
          onClick: $setup.Circulation
        }, "Circulation", 8 /* PROPS */, _hoisted_41),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn_issue",
          disabled: $setup.btnIssueFlg,
          onClick: $setup.IssueSaleNote
        }, "Issue Sales Note", 8 /* PROPS */, _hoisted_42)
      ], 512 /* NEED_PATCH */), [
        [_vShow, $setup.tblShowFlg]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_43, _hoisted_45, 512 /* NEED_PATCH */), [
        [_vShow, $setup.tblShowFlg]
      ])
    ]),
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_46, [
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.statusData.scan_kdp_approval, (info) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: info.id
                }, [
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createElementVNode("label", _hoisted_54, _toDisplayString($setup.statusData.distributorName), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _createElementVNode("label", _hoisted_57, _toDisplayString(info.salesNo), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _hoisted_59,
                    _createElementVNode("label", _hoisted_60, _toDisplayString(info.status?.status == '5'? '代理店確認待ち' : info.status?.status == '6'? '代理店承認待ち':  info.status?.description), 1 /* TEXT */)
                  ]),
                  _hoisted_61,
                  _hoisted_62,
                  _createElementVNode("table", _hoisted_63, [
                    _createElementVNode("tr", null, [
                      _hoisted_64,
                      _createElementVNode("td", _hoisted_65, _toDisplayString(info.drafterId?.userId), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_66, _toDisplayString((info.drafterId?.givenName || '') + ' ' + (info.drafterId?.familyName || '')), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_67, _toDisplayString(info.issueDate ? info.issueDate.slice(0, 4) + '/' + info.issueDate.slice(4, 6)+ '/' + info.issueDate.slice(6, 8) : ''), 1 /* TEXT */)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_68,
                      _createElementVNode("td", _hoisted_69, _toDisplayString(info.smcConfirmerId?.userId), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_70, _toDisplayString((info.smcConfirmerId?.givenName || '') + ' ' + (info.smcConfirmerId?.familyName || '')), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_71, _toDisplayString(info.smcConfirmDate ? info.smcConfirmDate.slice(0, 4) + '/' + info.smcConfirmDate.slice(4, 6)+ '/' + info.smcConfirmDate.slice(6, 8) : ''), 1 /* TEXT */)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_72,
                      _createElementVNode("td", _hoisted_73, _toDisplayString(info.approverId?.userId), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_74, _toDisplayString((info.approverId?.givenName || '') + ' ' + (info.approverId?.familyName || '')), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_75, _toDisplayString(info.smcApproveDate ? info.smcApproveDate.slice(0, 4) + '/' + info.smcApproveDate.slice(4, 6)+ '/' + info.smcApproveDate.slice(6, 8) : ''), 1 /* TEXT */)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_76,
                      _createElementVNode("td", _hoisted_77, _toDisplayString(info.distributorConfirmer1Id?.userId), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_78, _toDisplayString((info.distributorConfirmer1Id?.givenName || '') + ' ' + (info.distributorConfirmer1Id?.familyName || '')), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_79, _toDisplayString(info.distributorConfirm1Date ? info.distributorConfirm1Date.slice(0, 4) + '/' + info.distributorConfirm1Date.slice(4, 6)+ '/' + info.distributorConfirm1Date.slice(6, 8) : ''), 1 /* TEXT */)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_80,
                      _createElementVNode("td", _hoisted_81, _toDisplayString(info.distributorConfirmer2Id?.userId), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_82, _toDisplayString((info.distributorConfirmer2Id?.givenName || '') + ' ' + (info.distributorConfirmer2Id?.familyName || '')), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_83, _toDisplayString(info.distributorConfirm2Date ? info.distributorConfirm2Date.slice(0, 4) + '/' + info.distributorConfirm2Date.slice(4, 6)+ '/' + info.distributorConfirm2Date.slice(6, 8) : ''), 1 /* TEXT */)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_84,
                      _createElementVNode("td", _hoisted_85, _toDisplayString(info.distributorConfirmer3Id?.userId), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_86, _toDisplayString((info.distributorConfirmer3Id?.givenName || '') + ' ' + (info.distributorConfirmer3Id?.familyName || '')), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_87, _toDisplayString(info.distributorConfirm3Date ? info.distributorConfirm3Date.slice(0, 4) + '/' + info.distributorConfirm3Date.slice(4, 6)+ '/' + info.distributorConfirm3Date.slice(6, 8) : ''), 1 /* TEXT */)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_88,
                      _createElementVNode("td", _hoisted_89, _toDisplayString(info.distributorConfirmer4Id?.userId), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_90, _toDisplayString((info.distributorConfirmer4Id?.givenName || '') + ' ' + (info.distributorConfirmer4Id?.familyName || '')), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_91, _toDisplayString(info.distributorConfirm4Date ? info.distributorConfirm4Date.slice(0, 4) + '/' + info.distributorConfirm4Date.slice(4, 6)+ '/' + info.distributorConfirm4Date.slice(6, 8) : ''), 1 /* TEXT */)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_92,
                      _createElementVNode("td", _hoisted_93, _toDisplayString(info.distributorConfirmer5Id?.userId), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_94, _toDisplayString((info.distributorConfirmer5Id?.givenName || '') + ' ' + (info.distributorConfirmer5Id?.familyName || '')), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_95, _toDisplayString(info.distributorConfirm5Date ? info.distributorConfirm5Date.slice(0, 4) + '/' + info.distributorConfirm5Date.slice(4, 6)+ '/' + info.distributorConfirm5Date.slice(6, 8) : ''), 1 /* TEXT */)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_96,
                      _createElementVNode("td", _hoisted_97, _toDisplayString(info.distributorApproverId?.userId), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_98, _toDisplayString((info.distributorApproverId?.givenName || '') + ' ' + (info.distributorApproverId?.familyName || '')), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_99, _toDisplayString(info.distributorApproveDate ? info.distributorApproveDate.slice(0, 4) + '/' + info.distributorApproveDate.slice(4, 6)+ '/' + info.distributorApproveDate.slice(6, 8) : ''), 1 /* TEXT */)
                    ])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ])
      ])
    ])
  ]))
}